import React, { Component } from "react";
import Cookies from "universal-cookie";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";

import withAuth from "../../hoc/withAuth";
import MainLayout from "../../components/layouts/MainLayout";
import SelectDealer from "../../components/selects/SelectDealer";

import { otodisService } from "../../services/OtodisService";

import { Form, DatePicker, Button, Input, Modal, Row, Col, Select, Space, Table, Tooltip } from "antd";
import { ExportOutlined, CopyOutlined } from "@ant-design/icons";
import SelectTypeBill from "../../components/selects/SelectTypeBill";

class UpdateStatusBill extends Component {
  token = new Cookies().get("_bbn_tn");
  tableColumn = [
    {
      title: "Kode Order",
      dataIndex: "order_code",
      width: 150,
      render: (value, row) => {
        return (
          <div>
            <span>{value}</span>
            &nbsp;
            <Tooltip title="Click untuk copy kode order" color={"cyan"}>
              <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Nama Pemesan",
      dataIndex: "customer_doc_name",
      key: "customer_doc_name",
      width: 100,
    },
    {
      title: "Tgl Pengugasan",
      dataIndex: "create_date",
      key: "create_date",
      width: 70,
    },
    {
      title: "Usia Order",
      dataIndex: "create_date",
      key: "usia_order",
      width: 75,
      render: (value) => {
        const usia = dayjs().diff(dayjs(value), "days");
        return `${usia} hari`;
      },
      sorter: (a, b) => {
        const usiaA = dayjs().diff(dayjs(a.create_date), "days");
        const usiaB = dayjs().diff(dayjs(b.create_date), "days");
        return usiaA - usiaB;
      },
    },
    {
      title: `No Mesin`,
      dataIndex: "vehicle_engine_number",
      key: "vehicle_engine_number",
      width: 85,
      render: (value, row) => {
        return (
          <div>
            <span>{value}</span>
            &nbsp;
            <Tooltip title="Click untuk copy kode order" color={"cyan"}>
              <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "No Tagihan Bill",
      dataIndex: "bill_invoice_number",
      key: "bill_invoice_number",
      width: 80,
    },
    {
      title: "Status Bill",
      dataIndex: "bill_status",
      key: "bill_status",
      width: 70,
    },
    {
      title: "Nilai Bill",
      dataIndex: "bill_nominal",
      key: "bill_nominal",
      width: 70,
      render: (value) => {
        return this.numberWithCommas(value);
      },
    },
    {
      title: "Tanggal Penagihan Bill",
      dataIndex: "bill_submitted_date",
      key: "bill_submitted_date",
      width: 100,
    },
    {
      title: "Tanggal Lunas Bill",
      dataIndex: "bill_paid_date",
      key: "bill_paid_date",
      width: 80,
    },
    {
      title: "Remark1",
      dataIndex: "remark1",
      key: "remark1",
      width: 80,
    },
    {
      title: "Remark2",
      dataIndex: "remark2",
      key: "remark2",
      width: 80,
    },
    {
      title: "Status BBN",
      dataIndex: "transfer_title_status",
      key: "transfer_title_status",
      width: 80,
    },
  ];
  generateFileCsv = React.createRef();

  constructor(props) {
    super(props);

    const { match } = this.props;
    const code_svb = match.params.code_svb;

    this.initState = {
      loadingButton: false,
      totalAmount: 0,

      codeSVB: code_svb,
      filterType: "INVOICE_NUMBER",
      filterTypeBill: "BILL_PROSES",
      filterStatusBbn: "UPLOADED",
      filterDealer: null,
      filterDate: "",
      filterInvoiceNumber: "",
      filterEngineNumber: "",

      tableSelectedRowKeys: [],
      dataBill: [],
      dataExport: [],
      pageSize: 100,
    };

    this.state = { ...this.initState };
  }

  tableGetVisibleColumnsWidth = () => {
    const visibleColumns = this.tableColumn();
    return visibleColumns.reduce((total, col) => {
      return total + (col.width || 120); // fallback default width
    }, 0);
  };

  disabledDate = (current) => {
    const cutoff = dayjs("2024-05", "YYYY-MM");
    return current && current.toDate() < cutoff;
  };

  handleFieldChange = (field, value) => {
    this.setState({ [field]: value });
  };

  changeFilterDateOrder = (date, dateString) => {
    this.setState({
      dataLeftStock: [],
      filterDate: dateString,
    });
  };

  copyToClipboard = async (data) => {
    await navigator.clipboard.writeText(data);
  };

  numberWithCommas = (x) => {
    return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0;
  };

  onClickProcessData = async () => {
    // await this.fetchDataOrder();
    await this.fetchData();
  };

  fetchData = async () => {
    const filter = this.state;

    const payload = {
      service_bureau_code: this.state.codeSVB,
      type_bill: this.state.filterTypeBill,
      transfer_title_status: this.state.filterStatusBbn,
      dealer_code: filter.filterDealer?.trim(),
    };

    console.log("params", payload);

    if (!filter.filterDealer) {
      Modal.error({ title: "Validation Error", content: "Dealer is Required" });
      return false;
    }

    if (filter.filterType === "ENGINE_NUMBER") {
      if (!filter.filterEngineNumber) {
        Modal.error({ title: "Validation Error", content: "Nomor Mesin is Required" });
        return false;
      }
      payload.vehicle_engine_number = filter.filterEngineNumber?.trim();
    } else if (filter.filterType === "INVOICE_NUMBER") {
      if (!filter.filterDate) {
        Modal.error({ title: "Validation Error", content: "Tanggal Order is Required" });
        return false;
      }
      if (!filter.filterInvoiceNumber) {
        Modal.error({ title: "Validation Error", content: "Nomor Tagihan is Required" });
        return false;
      }

      const dateStart = dayjs(filter.filterDate).clone().startOf("month").format("YYYY-MM-DD");
      const dateEnd = dayjs(filter.filterDate).clone().endOf("month").format("YYYY-MM-DD");

      payload.date_start = dateStart;
      payload.date_end = dateEnd;
      payload.invoice_number = filter.filterInvoiceNumber?.trim();
    }

    this.setState({
      loadingButton: true,
      dataBill: [],
    });

    // console.log("params", payload);

    otodisService.setToken(this.token);
    otodisService
      .updateStatusBill(payload)
      .then(async (resp) => {
        // console.log("resp", resp.data.data);

        this.setState({
          dataBill: resp.data.data,
          loadingButton: false,
        });
      })
      .catch(async (reason) => {
        this.setState({
          dataBill: [],
          loadingButton: false,
        });

        Modal.error({
          title: "Error",
          content: "Get Data Failed, " + reason.message,
        });
      });
  };

  onClickExport = async () => {
    let dataGenerate = this.state.tableSelectedRowKeys;
    let dataParsed = [["Kode Order", "Nama Pemesan", "Tgl Pengugasan", "Usia Order", "No Mesin", "No Tagihan Bill", "Status Bill", "Nilai Bill", "Tanggal Penagihan Bill", "Tanggal Lunas Bill", "Remark1", "Remark2", "Status BBN"]];
    await dataGenerate.map((v) => {
      const usia = dayjs().diff(dayjs(v.create_date), "days");

      return dataParsed.push([v.order_code, v.customer_doc_name, v.create_date, usia, v.vehicle_engine_number, v.bill_invoice_number, v.bill_status, v.bill_nominal, v.bill_submitted_date, v.bill_paid_date, v.remark1, v.remark2, v.transfer_title_status]);
    });

    if (dataParsed.length < 1) {
      Modal.error({
        title: "Validation Error",
        content: "Tidak Ada Data yang Dipilih",
      });
      return false;
    }

    this.setState({
      loadingButton: true,
    });

    try {
      await this.setState({
        dataExport: dataParsed,
      });

      this.generateFileCsv.current.link.click();
      this.setState({
        loadingButton: false,
      });
    } catch (error) {
      Modal.error({
        title: "Process Error",
        content: error.message,
      });
    }
  };

  render() {
    const rowTableSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          tableSelectedRowKeys: selectedRows,
        });
      },
    };
    return (
      <React.Fragment>
        <MainLayout defaultOpenKeys={["15pembayaran"]} defaultSelectedKeys={["21updatestatustagihan"]}>
          <div style={{ padding: 10, margin: 10, background: "#FFF" }}>
            <Form name="form-filter" layout="vertical" style={{ padding: 8 }}>
              <Row>
                <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                  <SelectTypeBill value={this.state.filterTypeBill} onChangeValue={(value) => this.handleFieldChange("filterTypeBill", value)} />
                </Col>
                <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                  <Form.Item label="Cari Menggunakan">
                    <Select value={this.state.filterType} onChange={(value) => this.handleFieldChange("filterType", value)} placeholder="Select Type Filter">
                      <Select.Option key="ENGINE_NUMBER">Nomor Mesin</Select.Option>
                      <Select.Option key="INVOICE_NUMBER">Nomor Tagihan</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                  <Form.Item label="Status BBN">
                    <Select value={this.state.filterStatusBbn} onChange={(value) => this.handleFieldChange("filterStatusBbn", value)} placeholder="Pilih Status">
                      <Select.Option key="UPLOADED" value="UPLOADED">
                        BELUM LUNAS
                      </Select.Option>
                      {/* <Select.Option key="GENERATED" value="GENERATED">
                        LUNAS NOTICE
                      </Select.Option> */}
                    </Select>
                  </Form.Item>
                </Col>
                <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 300 }}>
                  <SelectDealer value={this.state.filterDealer} onChangeValue={(value) => this.handleFieldChange("filterDealer", value)} />
                </Col>
                {this.state.filterType === "ENGINE_NUMBER" && (
                  <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                    <Form.Item label="Nomor Mesin">
                      <Input value={this.state.filterEngineNumber} onChange={(event) => this.handleFieldChange("filterEngineNumber", event.target.value)} />
                    </Form.Item>
                  </Col>
                )}
                {this.state.filterType === "INVOICE_NUMBER" && (
                  <React.Fragment>
                    <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                      <Form.Item label="Tanggal Order">
                        <DatePicker onChange={this.changeFilterDateOrder} picker="month" disabledDate={this.disabledDate} />
                      </Form.Item>
                    </Col>
                    <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                      <Form.Item label="Nomor Tagihan">
                        <Input value={this.state.filterInvoiceNumber} onChange={(event) => this.handleFieldChange("filterInvoiceNumber", event.target.value)} />
                      </Form.Item>
                    </Col>
                  </React.Fragment>
                )}
                <Col style={{ paddingLeft: 2, paddingRight: 2 }}>
                  <Form.Item label="&nbsp;">
                    <Space.Compact style={{ width: "100%" }}>
                      <Button onClick={this.onClickProcessData} type="primary" title="filter" style={{ minWidth: "65%", background: "#1784b8", borderColor: "#1784b8" }} loading={this.state.loadingButton}>
                        Cari & Update Status Bill
                      </Button>
                      &nbsp;
                      <Button onClick={this.onClickExport} type="primary" icon={<ExportOutlined />} title="export excel" style={{ minWidth: "35%", background: "#17a2b8", borderColor: "#17a2b8" }} loading={this.state.loadingButton}>
                        Export
                      </Button>
                    </Space.Compact>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <CSVLink data={this.state.dataExport} filename="data-order.csv" ref={this.generateFileCsv} target="_blank" style={{ display: "none" }}>
              Export
            </CSVLink>
            <Row>
              <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }}>
                <Table
                  rowSelection={rowTableSelection}
                  scroll={{ x: 700 }}
                  rowKey={"order_code"}
                  size={"small"}
                  loading={this.state.loadingButton}
                  columns={this.tableColumn}
                  dataSource={this.state.dataBill}
                  pagination={{ pageSize: this.state.pageSize }}
                  className="text-uppercase"
                  style={{ marginTop: 20, fontSize: "10%" }}
                />
              </Col>
            </Row>
          </div>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(UpdateStatusBill);
